module.exports = __webpack_public_path__ + "static/img/MickMalthouse.70bc2d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MickMalthouse.jpg
// module id = XpNo
// module chunks = 0